"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _FormRow = require("./FormRow.styles");

var _propTypes2 = _interopRequireDefault(require("../../../constants/propTypes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 *  This is a layout component for Forms.
 *  We are intentionally excluding `dataTestId` for layout type components.
 */
var FormRow = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(FormRow, _React$PureComponent);

  var _super = _createSuper(FormRow);

  function FormRow(props) {
    var _this;

    _classCallCheck(this, FormRow);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "validateInput", function () {
      var errors = [];
      var keys = Object.keys(_this.inputRefs);
      keys.forEach(function (key) {
        var error = _this.inputRefs[key].current && _this.inputRefs[key].current.validateInput();

        if (error) {
          errors.push(error);
        }
      });
      return errors;
    });

    _defineProperty(_assertThisInitialized(_this), "assignRefsToChildren", function () {
      var children = _this.props.children;
      _this.inputRefs = [];
      return _react.default.Children.map(children, function (child) {
        if (_typeof(child) === 'object' && !(0, _isNil.default)(child)) {
          var ref; // being really really really careful...

          if (child && child.type && child.type.prototype && child.type.prototype.render) {
            ref = _react.default.createRef();

            _this.inputRefs.push(ref);
          }

          return _react.default.cloneElement(child, {
            ref: ref,
            className: 'c-form-row-child'
          });
        }

        return child;
      });
    });

    if (props.children.length > 2 && typeof props.children !== 'string') {
      console.warn('Per design, FormRows should 1 or two columns. Never More.'); // eslint-disable-line
    }

    _this.inputRefs = [];
    return _this;
  }

  _createClass(FormRow, [{
    key: "render",
    value: function render() {
      var className = this.props.className;
      var updatedChildren = this.assignRefsToChildren();
      return /*#__PURE__*/_react.default.createElement(_FormRow.StyledFormRow, {
        className: ['c-form-row', className].join(' ')
      }, updatedChildren);
    }
  }]);

  return FormRow;
}(_react.default.PureComponent);

_defineProperty(FormRow, "propTypes", {
  /** children can be any valid node or array of valid nodes */
  children: _propTypes2.default.children,

  /** Class override */
  className: _propTypes.default.string
});

_defineProperty(FormRow, "defaultProps", {
  children: [],
  className: ''
});

var _default = FormRow;
exports.default = _default;